import makeStyles from '@material-ui/core/styles/makeStyles'

const useStyles = makeStyles(theme => ({
    upperDisplay: {
        width: "86%",
        marginTop: "25px",
        padding: "25px",
        background:
          "linear-gradient(90deg, rgba(222, 212, 245,0.8130602582830007) 0%, rgba(247,243,255,1) 100%)",
      },
      secondHeading: {
        fontFamily: "Montserrat",
        color: "#6f59a6",
        fontSize: "40px",
        fontWeight: "bold",
      },
      filterContainer2: {
        padding: "10px",
        display: "flex",
      },
      select: {
        fontSize: "16px",
        whiteSpace: 'nowrap'
      },
      rightRotated: { transform: "rotate(-90deg)" },
}))

export default useStyles